import React from 'react';
import { Popover, Tooltip } from 'antd';
import DownloadLink from '@/components/DownloadLink';
import qrCodeImg from '@/assets/images/icon_code.svg';

const AuthorizeWX = ({ weAppAuthData, getWeAppAuthData, shopName }) => {
  const handleQRCode = (visible) => visible && getWeAppAuthData();
  return (
    <Popover
      zIndex={11}
      content={
        <div style={{ display: 'flex' }}>
          {weAppAuthData?.isAuthed ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {weAppAuthData?.qrcode ? (
                <div
                  style={{
                    width: '200px',
                    userSelect: 'none',
                    textAlign: 'center',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      marginBottom: '30px',
                      paddingBottom: '12px',
                      color: '#333',
                      fontWeight: '500',
                      borderBottom: '1px solid #e8e8e8',
                    }}
                  >
                    {shopName}
                  </div>
                  <img
                    width={200}
                    height={200}
                    src={weAppAuthData.qrcode}
                    alt={weAppAuthData.name}
                  />
                  <DownloadLink text="点击下载" link={weAppAuthData.qrcode} type="button" />
                </div>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
          <div
            style={{
              width: '200px',
              userSelect: 'none',
              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                marginBottom: '30px',
                paddingBottom: '12px',
                color: '#333',
                fontWeight: '500',
                borderBottom: '1px solid #e8e8e8',
              }}
            >
              丰食APP
            </div>
            <img
              width={200}
              height={200}
              src="https://fx-festatic-1314282223.cos.ap-guangzhou.myqcloud.com/localservice/fs-manage/%E4%B8%8B%E8%BD%BD%E4%BA%8C%E7%BB%B4%E7%A0%81.png"
              alt="丰食APP"
            />
            <DownloadLink
              text="点击下载"
              link="https://fx-festatic-1314282223.cos.ap-guangzhou.myqcloud.com/localservice/fs-manage/%E4%B8%8B%E8%BD%BD%E4%BA%8C%E7%BB%B4%E7%A0%81.png"
              type="button"
            />
          </div>
        </div>
      }
      trigger="click"
      placement="topRight"
      onVisibleChange={handleQRCode}
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      <Tooltip placement="bottom" title="店铺二维码">
        <img src={qrCodeImg} className="qr-code" alt="店铺二维码" />
      </Tooltip>
    </Popover>
  );
};

export default AuthorizeWX;
